import { LENGTH_LABELS, LENGTH_TAGS } from '../constants';
import getOption from './getOption';

var lengthSort = function lengthSort(a, b) {
  return LENGTH_TAGS.indexOf(a.toLowerCase()) - LENGTH_TAGS.indexOf(b.toLowerCase());
};

var length = function length(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'lengthFilter';
  var options = values.sort(lengthSort).map(function (length) {
    return {
      ariaLabel: "Click to filter by ".concat(LENGTH_LABELS[length.toLowerCase()]),
      label: LENGTH_LABELS[length.toLowerCase()],
      value: length
    };
  });
  return {
    expand: false,
    filter: function filter(product, value) {
      return product.properties.lengthDisplay === value;
    },
    label: label,
    param: param,
    options: options,
    selected: getOption(options, urlParams.get(param))
  };
};

export default length;